import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import CONFIG from 'src/app/app.config';
import { UserdataService } from 'src/app/services/user/userdata.service';
import { BehaviorSubject } from 'rxjs';

// declare var SqPaymentForm: any;
@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  packages$ = new BehaviorSubject<any[]>(CONFIG.APPLICATION.PACKAGES);
  isActive = false;
  contact_url = CONFIG.APPLICATION.ADDITIONAL.CONTACT_US;
  paymentPath = CONFIG.APPLICATION.PATHS.PAYMENT;
  items = CONFIG.APPLICATION.FEATURES;
  paymentModalRef: any;
  
  constructor(private userDataService: UserdataService,
    private router: Router) {}

  ngOnInit(): void {
    this.userDataService.localData$.subscribe((data) => {
       if(!data) return;
      let pkges = this.packages$.getValue();
      pkges.forEach((pkg, index) => {
        // Mark as purchase otherwise toggle it off
        pkges[index]["purchased"] = (pkg["name"] == data.subscription.plan);
      });
      this.packages$.next(pkges);
    });
  }

  openFeedback() {
    (window as any)['appzi'].openWidget(CONFIG.APPLICATION.FEEDBACK.WIDGET_ID);
  }

  purchase(pricePackage: any) {
    if(pricePackage.name == "Institution") {
      window.open(this.contact_url, "_blank");
      return;
    }
    this.router.navigate([this.paymentPath], {queryParams: {p: pricePackage.name}});
  }
}
